module.exports = __webpack_public_path__ + "media/applicants/icon-arrow-246ab2c2.png";